export const createFleetCardSlug = (title = "") => {
  const slug = String(title)
    .trim()
    .toLowerCase()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+/g, "-");

  return slug || "boat";
};

export const resolveFleetCardSlug = (card = {}) => {
  const stored = String(card.slug || "").trim().toLowerCase();

  if (stored) {
    return stored;
  }

  return createFleetCardSlug(
    card.title || card.category || card.boatName || card.type
  );
};

export const getYachtDetailsPath = (card = {}, options = {}) => {
  const slug = resolveFleetCardSlug(card);
  const base = `/yachtdetails/${encodeURIComponent(slug)}`;

  if (options.trip) {
    return `${base}?trip=${encodeURIComponent(options.trip)}`;
  }

  return base;
};
